const isPassword = new RegExp(/^(?=.*[@!#$/\\])[@!#$&*()/\\a-zA-Z0-9]{6,30}$/);
const isText = new RegExp(/[a-zA-Z]$/);
const isNumber = new RegExp(/^([0-9])+$/);
const isNumberNoZero = new RegExp(/^([1-9])+$/);
const isTextAndComma = new RegExp(/[,a-zA-Z]$/);
const isTextAndSpace = new RegExp(/[,a-zA-Z\ ]$/);
const isNumberAndComma = new RegExp(/[,0-9]$/);
const isTextAndNumbersAndTripleChar = new RegExp(/^([A-Z\+a-z\+0-9\+_,\-.])+$/);
const isTextAndNumbersAndQuadChar = new RegExp(/^([A-Z\+a-z\+0-9\+_,\-.])+$/);
const isIP = new RegExp(/^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/);

const checkIfSrIsCorrect = (mask) => {
  const numMask = Number(mask);
  let result = false;
  switch (numMask) {
    case 255:
      result = true;
      break;

    case 252:
      result = true;
      break;

    case 248:
      result = true;
      break;
  
    case 240:
      result = true;
      break;

    case 224:
      result = true;
      break;

    case 192:
      result = true;
      break;
    
    case 128:
      result = true;
      break;
  
    case 0:
      result = true;
      break;

    default:
      break;
  }

  return result;
};

const verfyIpAndMask = (item) => {

}

const valuesAnalyze = {
  checkPassword: (pass) => {
    return isPassword.test(pass);
  },
  checkText: (txt) => {
    return isText.test(txt);
  },
  checkNumber: (num) => {
    return isNumber.test(num);
  },
  isNumberNoZero: (num) => {
    return isNumberNoZero.test(num);
  },
  checkTextAndComma: (char) => {
    return isTextAndComma.test(char);
  },
  isNumberAndComma: (char) => {
    return isNumberAndComma.test(char);
  },
  isTextAndSpace: (char) => {
    return isTextAndSpace.test(char);
  },
  isTripleChar: (char) => {
    return isTextAndNumbersAndTripleChar.test(char);
  },
  isQuadChar: (char) => {
    return isTextAndNumbersAndQuadChar.test(char);
  },
  isIP: (ip) => {
    const result = ip.split('.').map((octate) => {
      return Number(octate) >= 0 && Number(octate) <= 255 ? true : false
    });
    return result.includes(false) ? false : isIP.test(ip);
  },
  isMask: (mask) => {
    const checkMaskOctate = mask.split('.');
    const result = checkMaskOctate.map((octate) => {
      return checkIfSrIsCorrect(octate) ? true : false
    });

    return result.includes(false) ? false : true;
    
  },
};

export default valuesAnalyze;
